<div class="content-container">
  <div class="card card-w-title">
    <div class="ui-g">
      <div class="ui-g-12">
        <div style="display: flex; flex-wrap: wrap">
          <div style="flex-grow: 1; min-width: 360px; height: 170px">
            <div class="engineius-text">
              Vehicle movement made easy for
              <div><img class="logo" src="{{ logo }}" alt="{{ orgName }}" /></div>
            </div>
          </div>

          <div
            style="
              flex-shrink: 1;
              overflow: hidden;
              width: 250px;
              height: 170px;
              text-align: center;
            "
          >
            <video
              style="margin-left: -40%; margin-top: -20%"
              muted
              autoplay
              loop
              id="video"
              width="420px"
              height="252px"
              class="img"
            >
              <source src="assets/video/EngineiusLoop420.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>

      <div class="ui-g-5 ui-lg-5 ui-md-12 ui-sm-12">
        <div class="ui-g-4 ui-sm-12">
          <div class="job-volumes param-1" style="border-radius: 3px">
            <div class="ui-g-2"><i class="vme-material-icons">&#xe913;</i></div>
            <div class="ui-g-7">
              <a (click)="goToInbox($event, customerInboxType_Live)">Live Now</a>
            </div>
            <div class="ui-g-3 param-value">{{ data.liveJobs }}</div>
          </div>
        </div>
        <div class="ui-g-4 ui-sm-12" style="padding-bottom: 1em">
          <div class="job-volumes param-2" style="border-radius: 3px">
            <div class="ui-g-2"><i class="vme-material-icons">&#xe91e;</i></div>
            <div class="ui-g-7">
              <a (click)="goToInbox($event, customerInboxType_Unallocated)">Unallocated</a>
            </div>
            <div class="ui-g-3 param-value">{{ data.unallocatedOrders }}</div>
          </div>
        </div>
        <div class="ui-g-4 ui-sm-12">
          <div class="job-volumes param-3" style="border-radius: 3px">
            <div class="ui-g-2"><i class="vme-material-icons">&#xe921;</i></div>
            <div class="ui-g-7">
              <a (click)="goToInbox($event, customerInboxType_Waiting)">Waiting</a>
            </div>
            <div class="ui-g-3 param-value">{{ data.waiting }}</div>
          </div>
        </div>
        <div class="ui-g-12">
          <h2 class="sub-header-bar">Order Location Map</h2>
          <div style="height: 870px">
            <map-control
              [tasks]="taskList"
              [readOnly]="true"
              (selectedTaskChange)="taskClick($event)"
              [customStyle]="{ height: 'calc(100%)', 'border-radius': '3px' }"
            ></map-control>
          </div>
        </div>
      </div>

      <div class="ui-g-7 ui-lg-7 ui-md-12 ui-sm-12" style="padding-top: 0px">
        <dashboard-customer-kpi-toplevel></dashboard-customer-kpi-toplevel>

        <!--                    <div class="ui-g-12" *ngIf="false">-->
        <!--                        <h2 style="margin: .5em 0 .4em;">Driver Status</h2>-->
        <!--                        -->
        <!--                        <div class="ui-g">-->
        <!--                            <div class="ui-g-4">-->
        <!--                                <div class="driver-status">-->
        <!--                                    <div class="ui-g-8">Started</div>-->
        <!--                                    <div class="ui-g-4 param-value">{{ data.started }}</div>-->
        <!--                                </div>-->
        <!--                            </div>-->
        <!--                            <div class="ui-g-4">-->
        <!--                                <div class="driver-status">-->
        <!--                                    <div class="ui-g-8">Completed</div>-->
        <!--                                    <div class="ui-g-4 param-value">{{ data.completed }}</div>-->
        <!--                                </div>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                    </div>-->

        <!--                    <div class="ui-g-12">-->
        <!--                        <h2 style="margin-top: 1.5em; margin-bottom: .5em;">Orders By Day</h2>-->

        <!--                        <p-chart type="bar" [data]="ordersByDay" [options]="ordersByDayOptions"></p-chart>-->
        <!--                    </div>-->

        <!--                    <div class="ui-g-12">-->
        <!--                        <h2 style="margin-top: 1.5em; margin-bottom: .5em;">Orders Completing</h2>-->

        <!--                        <p-chart type="bar" [data]="ordersByHour" [options]="ordersByHourOptions" (onDataSelect)="selectData($event)"></p-chart>-->
        <!--                    </div>-->
      </div>
    </div>
  </div>
</div>
